module.exports = "/virtual-football-league/img/amblems/right/logos/Burnley.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Burnley.png
// module id = 2165
// module chunks = 4